import { render, staticRenderFns } from "./PedidoItemDetalleGrupo.vue?vue&type=template&id=3fe26552&scoped=true"
import script from "./PedidoItemDetalleGrupo.vue?vue&type=script&lang=js"
export * from "./PedidoItemDetalleGrupo.vue?vue&type=script&lang=js"
import style0 from "./PedidoItemDetalleGrupo.vue?vue&type=style&index=0&id=3fe26552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe26552",
  null
  
)

export default component.exports